import { isKiosk } from '../../../utils/isKiosk';

interface GeoLocationData {
  state?: string;
  country?: string;
}
const shouldShowCookieSettingsButton = (geoLocationData: GeoLocationData) => {
  const isKioskMode = isKiosk();

  return (
    !isKioskMode
    && geoLocationData?.state?.toUpperCase() === 'QC'
    && geoLocationData?.country?.toUpperCase() === 'CA'
  );
};

export default shouldShowCookieSettingsButton;
